import React from "react";

const ScreenFooter = (props) => {
  return (
    <div
      style={{
        position: "fixed",
        left: 0,
        bottom: 0,
        right: 0,
        height: 55,
        zIndex: 10000,
        backgroundColor: "#505659",
        color: "#eee",
      }}
    >
      {props.children}
    </div>
  );
};

export default ScreenFooter;
